import type { ITermManagementPreviewDisplay } from "components/shared/TermManagementPreviewSection";
import type { IAdvanceSlice } from "store/advancePaymentSlice";
import type { GeneralTabTerm } from "store/managementStore";

export function buildManagementPreviewDisplayFromSlice(slice: IAdvanceSlice): ITermManagementPreviewDisplay {
    return {
        title: slice.title ?? "",
        isbn: slice.legacyTermTitleEan13 ?? undefined,
        titleAvatarUrl: slice.titleAvatarUrl,
        author: slice.author ?? "",
        representative: slice.representative,
        beneficiaryAvatarUrl: slice.beneficiaryAvatarUrl,
        isTermDeleted: slice.isTermDeleted,
    };
}

export function buildManagementPreviewDisplayFromTerm(term: GeneralTabTerm): ITermManagementPreviewDisplay {
    return {
        title: term.title ?? "",
        isbn: term.legacyTermTitleEan13 ?? undefined,
        titleAvatarUrl: term.titleAvatarUrl,
        author: term.author ?? "",
        representative: term.representative,
        beneficiaryAvatarUrl: term.beneficiaryAvatarUrl,
    };
}

export function resolveManagementPreviewDisplayFromTerm(
    term: GeneralTabTerm | null | undefined,
): ITermManagementPreviewDisplay | null {
    if (!term) return null;
    return buildManagementPreviewDisplayFromTerm(term);
}

export function resolveManagementPreviewDisplay(
    term: GeneralTabTerm | null | undefined,
    slice?: IAdvanceSlice | null,
): ITermManagementPreviewDisplay | null {
    return (
        resolveManagementPreviewDisplayFromTerm(term) ?? (slice ? buildManagementPreviewDisplayFromSlice(slice) : null)
    );
}
